import styled from 'styled-components';

export const TimeLeftBox = styled.div`
  border-radius: var(--half-unit);
  background: var(--c-nl-500);
  box-shadow: 0 1.2px 9.6px 0 var(--shadow-color);
  backdrop-filter: blur(2px);
  padding: var(--half-unit);
`;
